import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import RegisteredInfoPage from "./pages/RegisteredInfoPage";
import Dashboard from "./pages/Dashboard";
import AdminUserApproval from "./pages/AdminUserApproval";
import AdminDownloadLogs from "./pages/AdminDownloadLogs";

import ClientRoute from "./routes/ClientRoute";
import AdminRoute from "./routes/AdminRoute";
import useAutoLogout from "./hooks/useAutoLogout";

import Firmware from "./pages/Firmware";
import ServiceRoute from "./routes/ServiceRoute";

import ServiceAdminRoute from "./routes/ServiceAdminRoute";
import ServiceAdminUsers from "./pages/ServiceAdminUsers";
import ServiceAdminDownloadLogs from "./pages/ServiceAdminDownloadLogs";

export default function App() {
  useAutoLogout(2);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Public routes */}
          <Route index element={<Home />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="registered" element={<RegisteredInfoPage />} />

          {/* Client docs */}
          <Route
            path="dashboard"
            element={
              <ClientRoute>
                <Dashboard />
              </ClientRoute>
            }
          />

          {/* Firmware (standard service route) */}
          <Route
            path="firmware"
            element={
              <ServiceRoute>
                <Firmware />
              </ServiceRoute>
            }
          />

          {/* Service admin: default landing = users management */}
          <Route
            path="service-admin"
            element={
              <ServiceAdminRoute>
                <ServiceAdminUsers />
              </ServiceAdminRoute>
            }
          />

          {/* Service admin: firmware page (so "Firmware" link does not land on users list) */}
          <Route
            path="service-admin/firmware"
            element={
              <ServiceAdminRoute>
                <Firmware />
              </ServiceAdminRoute>
            }
          />

          {/* Service admin logs */}
          <Route
            path="service-admin/logs"
            element={
              <ServiceAdminRoute>
                <ServiceAdminDownloadLogs />
              </ServiceAdminRoute>
            }
          />

          {/* Client admin users */}
          <Route
            path="admin"
            element={
              <AdminRoute>
                <AdminUserApproval />
              </AdminRoute>
            }
          />

          {/* Client admin logs */}
          <Route
            path="admin/logs"
            element={
              <AdminRoute>
                <AdminDownloadLogs />
              </AdminRoute>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
}
